import { render, staticRenderFns } from "./VolunteerPin.vue?vue&type=template&id=39a02d82&scoped=true&"
import script from "./VolunteerPin.vue?vue&type=script&lang=js&"
export * from "./VolunteerPin.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerPin.vue?vue&type=style&index=0&id=39a02d82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a02d82",
  null
  
)

export default component.exports